
import MyActivity from './my-activity'

export default MyActivity
